const s = require("./downloadButton.module.scss");

import { default as React, useState, forwardRef } from "react";
import classnames from "classnames";
import ReactDatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { ApplicationState } from "core/app";
import httpService from "core/infrastructure/http";
import { PageList } from "core/pages/pageList";
import { WithTranslation, withTranslation } from "react-i18next";

interface State {
    applicationState: ApplicationState;
    pageConfig: PageList;
    formats: string[];
    search?: any;
}

const DownloadButton = ({ applicationState, pageConfig, formats, search, t }: State & WithTranslation) => {
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [showPopup, setShowPopup] = useState(false);
    const [showWait, setShowPleaseWait] = useState(false);
    const [error, setError] = useState("");
    const [applyFilter, setApplyFilter] = useState(false);

    const download = (fileType: string) => {
        (async function runAsync() {

            setShowPleaseWait(true);
            let res = await httpService.apiDownload({
                applicationState: applicationState,
                route: applicationState.apiService + "/" + pageConfig.apiType + "/" + pageConfig.apiUrl + "/download",
                query: { FromUtc: startDate.toISOString(), ToUtc: endDate.toISOString(), FileType: fileType, Filter: applyFilter ? JSON.stringify(search) : "" },
                senderId: pageConfig.apiUrl
            })();
            if (res == "") {
                setError("");
                setShowPleaseWait(false);
                setShowPopup(false);
            } else {
                setError(res);
                setShowPleaseWait(false);
            }
        })();
    };
    const CweDateInput = forwardRef((a: any, ref) => {
        const cweDate = new Date(a.value);// applicationState.getCweTimeForDisplayPurposes(new Date(a.value));
        const cweString = cweDate.getFullYear() + "-" + ("0" + (cweDate.getMonth() + 1)).slice(-2) + "-" + ("0" + (cweDate.getDate())).slice(-2)
            + " " + ("0" + (cweDate.getHours())).slice(-2) + ":" + ("0" + (cweDate.getMinutes())).slice(-2);
        return <input className={classnames(s.parameter, "inputBorder")} type="text" value={cweString} onClick={a.onClick} readOnly />;
    });

    return <>
        <button className={s.pageButton} onClick={() => {
            if (applicationState.dateSteps.startsWith("H")) {
                setStartDate(new Date(applicationState.selectedDate));
                setEndDate(applicationState.getUntilFor1Hour());
            }
            else {
                setStartDate(applicationState.getRootUtcTime());
                setEndDate(applicationState.getUntilFor1Day());
            }
            setShowPopup(true);
        }}>{t("common:download")}</button>

        <div className={classnames(s.lightBox, showPopup ? "" : s.hidden)} onClick={() => { if (!showWait) { setShowPopup(false); } }} />
        <div className={classnames(s.popup, "shadow", showPopup && showWait ? "" : s.hidden)}>
            <h3 className={s.title}>{t("common:download")}</h3>
            <div style={{ marginTop: "50px", marginBottom: "50px" }}>{t("common:pleaseWait")}</div>
        </div>
        <div className={classnames(s.popup, "shadow", showPopup && !showWait ? "" : s.hidden)}>
            <h3 className={s.title}>{t("common:download")}</h3>

            <FontAwesomeIcon icon={faWindowClose} className={s.closeButton} onClick={() => { if (!showWait) { setShowPopup(false); } }} />
            <div className="inputlabel">{t("common:fromDateTime")}</div>
            <ReactDatePicker
                className="inputBorder"
                locale="en-GB"
                dateFormat="yyyy-MM-dd HH:mm"
                showYearPicker={applicationState.dateSteps == "Y"}
                customInput={<CweDateInput />}
                isClearable={false}
                fixedHeight
                todayButton="Today"
                selected={applicationState.getCweTimeForDisplayPurposes(startDate)}
                onChange={(date: Date) => date && setStartDate(applicationState.convertCweHourToUtcDate(date))}
                selectsStart
                startDate={applicationState.getCweTimeForDisplayPurposes(startDate)}
                endDate={applicationState.getCweTimeForDisplayPurposes(endDate)}
                //highlightDates={availableDates.map(d => new Date(d))}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={60}
                timeCaption="Hour"
            />
            <div className="inputlabel">{t("common:toDateTime")}</div>
            <ReactDatePicker
                className="inputBorder"
                locale="en-GB"
                dateFormat="yyyy-MM-dd HH:mm"
                showYearPicker={applicationState.dateSteps == "Y"}
                customInput={<CweDateInput />}
                isClearable={false}
                fixedHeight
                todayButton="Today"
                selected={applicationState.getCweTimeForDisplayPurposes(endDate)}
                onChange={(date: Date) => date && setEndDate(applicationState.convertCweHourToUtcDate(date))}
                selectsEnd
                startDate={applicationState.getCweTimeForDisplayPurposes(startDate)}
                endDate={applicationState.getCweTimeForDisplayPurposes(endDate)}
                //highlightDates={availableDates.map(d => new Date(d))}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={60}
                timeCaption="Hour"
            />

            <div style={{ color: "red", marginTop: "16px", marginBottom: "16px" }}>{error}</div>

            {search && Object.keys(search).length !== 0 &&
            <div>
                <input id="filter" type="checkbox" checked={applyFilter} onChange={e => setApplyFilter(e.target.checked)}/>
                <label htmlFor="filter" >{t("common:applyFilter")}</label>
            </div>}
            
            <div>
                <div>{formats.map(f => <button key={f} className={s.popupButton} onClick={() => download(f)}>{f.toUpperCase()}</button>)}</div>
                <span>{t("common:downloadAs")}</span>
            </div>
        </div>
    </>;
};

const translated = withTranslation()(DownloadButton);
export default translated;